module.exports = __webpack_public_path__ + "img/pre3-celular.7731aa42.jpg";